import { render } from "./Document.vue?vue&type=template&id=0253f032"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"

import "./Document.vue?vue&type=style&index=0&id=0253f032&lang=scss"
script.render = render

export default script